exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__group[data-v-860673b4]{display:flex;flex-direction:row;justify-content:space-between;width:100%}.form__group>div[data-v-860673b4]{width:calc(100%/var(--form-input-count) - 1.25rem*(var(--form-input-count) - 1)/var(--form-input-count))}@media (max-width:575px){.form__group[data-v-860673b4]{flex-direction:column}.form__group>div[data-v-860673b4]{width:100%}}", ""]);

// exports
